import { render, staticRenderFns } from "./BaseTabbedSection.vue?vue&type=template&id=344e657a"
import script from "./BaseTabbedSection.vue?vue&type=script&lang=js"
export * from "./BaseTabbedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports